class TrPriceRangeDisplay extends HTMLElement {
	selectors = {
		minimumRange: 'input[type="range"]:first-child',
		maximumRange: 'input[type="range"]:last-child',
		minimumValue: '[data-tr-js-price-range-min]',
		maximumValue: '[data-tr-js-price-range-max]'
	};

	attributes = {
		currencySymbol: 'data-tr-js-price-range-symbol'
	};

	stateClasses = {};

	connectedCallback() {
		this.priceRangeElement = this.closest('price-range');
		this.minimumRangeElement = this.priceRangeElement?.querySelector(
			this.selectors.minimumRange
		);
		this.maximumRangeElement = this.priceRangeElement?.querySelector(
			this.selectors.maximumRange
		);
		this.minimumValueElement = this.querySelector(this.selectors.minimumValue);
		this.maximumValueElement = this.querySelector(this.selectors.maximumValue);
		this.currencySymbol = this.getAttribute(this.attributes.currencySymbol);

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		this.updateValues();
	}

	bindEvents() {
		this.priceRangeElement?.addEventListener('input', this.onRangeInput);
		this.priceRangeElement?.addEventListener('change', this.onRangeInput);
	}

	onSectionLoad = event => {
		if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;

		this.updateValues();
	};

	onRangeInput = () => {
		this.updateValues();
	};

	updateValues() {
		if (
			!this.minimumRangeElement ||
			!this.maximumRangeElement ||
			!this.minimumValueElement ||
			!this.maximumValueElement
		)
			return;

		this.minimumValueElement.textContent = `${this.currencySymbol}${this.minimumRangeElement.value}`;
		this.maximumValueElement.textContent = `${this.currencySymbol}${this.maximumRangeElement.value}`;
	}

	destroy() {
		this.priceRangeElement?.removeEventListener('input', this.onRangeInput);
		this.priceRangeElement?.removeEventListener('change', this.onRangeInput);
	}
}

if (!customElements.get('tr-price-range-display')) {
	customElements.define('tr-price-range-display', TrPriceRangeDisplay);
}
